/**
 * Legacy server-provisioned Workspaces were titled with the owner's raw
 * principal id (`usr_<uuid>`). That title is storage metadata, never customer
 * copy: every display surface substitutes its own localized personal-workspace
 * label when this predicate matches.
 */
const OPAQUE_WORKSPACE_TITLE = /^usr_[A-Za-z0-9_-]+$/;
/**
 * Whether a persisted Workspace title is an opaque principal id rather than a
 * customer-facing name.
 * @param title - stored Workspace title.
 * @returns true for the legacy `usr_<id>` shape.
 */
export function isOpaqueWorkspaceTitle(title) {
    return OPAQUE_WORKSPACE_TITLE.test(title.trim());
}
//# sourceMappingURL=title.js.map